import { Descriptions } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import { CustomerReduced } from '@/core/domain/people/Customers/Customers.types';
import { applyCpfCnpjMask } from '@/utils/mask';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';

interface WorkOrderFormSummaryProps {
  customer?: CustomerReduced;
  vehicle?: CustomerVehicleReduced;
}

function WorkOrderFormSummary({
  customer,
  vehicle,
}: WorkOrderFormSummaryProps) {
  const intl = useIntl();

  const renderDocumentValue = () => {
    if (!customer) return;

    if (customer.foreignDocument) {
      return customer.foreignDocument;
    }
    if (customer.cpfCnpj) {
      return applyCpfCnpjMask(customer.cpfCnpj);
    }

    return '-';
  };

  return (
    <>
      <Descriptions
        bordered
        title={intl.formatMessage({ id: 'workOrders.domain.customer' })}
        style={{ marginTop: '16px' }}
        column={2}
      >
        {customer ? (
          <>
            <Descriptions.Item
              label={intl.formatMessage({ id: 'customers.domain.name' })}
              span={2}
            >
              {customer?.name}
            </Descriptions.Item>

            <Descriptions.Item
              label={
                !!customer.foreignDocument
                  ? 'Doc. identificação estrangeiro'
                  : intl.formatMessage({ id: 'customers.domain.cpfCnpj' })
              }
            >
              {renderDocumentValue()}
            </Descriptions.Item>
          </>
        ) : (
          <Descriptions.Item>
            <FormattedMessage id="workOrders.create.summary.customerNotSelected" />
          </Descriptions.Item>
        )}
      </Descriptions>
      <Descriptions
        bordered
        title={intl.formatMessage({ id: 'workOrders.domain.vehicle' })}
        style={{ marginTop: '24px' }}
        column={2}
      >
        {vehicle ? (
          <>
            <Descriptions.Item
              label={intl.formatMessage({
                id: 'workOrders.domain.vehicle.licensePlate',
              })}
              span={2}
            >
              {vehicle.licensePlate}
            </Descriptions.Item>
            <Descriptions.Item
              label={intl.formatMessage({
                id: 'workOrders.domain.vehicle.brand',
              })}
              span={2}
            >
              {vehicle.brandName}
            </Descriptions.Item>
            <Descriptions.Item
              label={intl.formatMessage({
                id: 'workOrders.domain.vehicle.model',
              })}
              span={2}
            >
              {vehicle.modelName}
            </Descriptions.Item>
          </>
        ) : (
          <Descriptions.Item>
            <FormattedMessage id="workOrders.create.summary.vehicleNotSelected" />
          </Descriptions.Item>
        )}
      </Descriptions>
    </>
  );
}

export default WorkOrderFormSummary;
